define.alias("ember-math-helpers/helpers/floor", "calendar/helpers/floor");